// 404 — playful but useful. Suggests likely destinations.

import { KbdChip } from '@/components/primitives/KbdChip';

const SUGGESTIONS = [
  { label: 'Day Book',        href: '/reports/day-book',  hint: 'F1' },
  { label: 'Vouchers',        href: '/vouchers',          hint: 'V' },
  { label: 'Reports Hub',     href: '/reports',           hint: 'R' },
  { label: 'Tenant Portal',   href: '/admin',             hint: 'Alt A' },
  { label: 'Keyboard help',   href: '/help',              hint: 'F1' },
];

export function NotFoundPage() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center gap-6 overflow-hidden bg-snow px-6 text-center">
      {/* faint glows */}
      <div aria-hidden className="pointer-events-none absolute -top-32 -left-32 h-[420px] w-[420px] rounded-full bg-cobalt opacity-[0.05] blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -bottom-32 -right-32 h-[360px] w-[360px] rounded-full bg-citrus opacity-[0.05] blur-3xl" />

      <div className="relative flex items-center gap-3">
        <img src="/brand/mark.svg" alt="" aria-hidden className="h-10 w-10" />
        <span className="font-display text-display-sm font-semibold text-obsidian" style={{ letterSpacing: 'var(--tracking-display)' }}>Orenza</span>
      </div>

      <div className="relative">
        <h1 className="font-display text-display-lg font-semibold text-obsidian" style={{ letterSpacing: 'var(--tracking-display)' }}>
          404
        </h1>
        <p className="mt-2 text-body-lg text-slate">
          That URL isn't anywhere on Orenza Billing.
        </p>
        {path && path !== '/' && (
          <p className="mt-1 font-mono text-caption text-cool">
            tried: {path}
          </p>
        )}
      </div>

      <div className="relative w-full max-w-lg rounded-md border border-mist bg-frost p-5">
        <div className="text-micro font-medium uppercase tracking-[0.16em] text-cool">Try one of these</div>
        <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
          {SUGGESTIONS.map((s) => (
            <li key={s.href}>
              <a
                href={s.href}
                className="flex items-center justify-between gap-2 rounded-sm border border-mist bg-haze px-3 py-2 text-body-sm text-cobalt transition hover:border-cobalt hover:bg-cobalt/[0.05]"
              >
                <span>{s.label}</span>
                {s.hint && <KbdChip>{s.hint}</KbdChip>}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <p className="relative text-caption text-cool">
        Or press <KbdChip>Ctrl K</KbdChip> for the command palette.
      </p>
    </div>
  );
}
